import { dispatch, parametric, subscription } from 'nike-re-framejs';
import { fromJS, List, Map } from 'immutable';
import onbClient from '../../../registration/util/client';
import { handleServerErrors } from '../../../registration/util/error';
import { loadForcedActions } from '../../reframe/h&s';
import { getForcedActionStatus } from '../step_forced_action_status/h&s';

export function fetchDocumentsUploadConfig(slot2requested) {
    onbClient
        .get('/documents/slot-list' + (slot2requested ? '?typ=SLOT2REQUESTED' : ''))
        .then(data => dispatch(processSlotList(data, slot2requested)))
        .catch(handleServerErrors());
}

export function removeUploadFile(slotDescription) {
    const { slot, page } = slotDescription;
    return db => db.removeIn(['dms', 'model', 'docs', slot, slotDescription.idDocDms, 'files', page]);
}

export function dbCommitUpdate(updater) {
    return db => {
        return db.update(updater);
    };
}

export function processSlotList(slotList, slot2requested) {
    return db => {
        const documents = slotList[0];
        const firstIdSlot = documents[0].idSlot;
        const selectFirstDocumentIfSingle = function(_db) {
            if (documents && documents.length === 1) {
                return _db
                    .setIn(['dms', 'model', 'selected', firstIdSlot], documents[0])
                    .setIn(['dms', 'model', 'active', firstIdSlot], true);
            }
            return _db;
        };
        let slotMap = Map();
        for (const documents of slotList) {
            slotMap = slotMap.set(documents[0].idSlot, fromJS(documents));
        }
        return db
            .setIn(['dms', 'slotList'], fromJS(slotMap))
            .setIn(['dms', 'model'], Map())
            .setIn(['dms', 'model', 'slot'], firstIdSlot)
            .setIn(['onboarding', 'slot2requested'], slot2requested)
            .update(selectFirstDocumentIfSingle);
    };
}

export function cleanDocumentsUpload() {
    return db => db.delete('dms');
}

function extractUploadedDocuments(model) {
    const documents = model.get('selected').reduce((acc, val) => {
        acc.push({
            doc_type: val.get('docType'),
            slot: val.get('idSlot'),
            version: model.getIn(['docs', val.get('idSlot'), val.get('idDocDms'), 'files', 1, 'version'])
        });
        return acc;
    }, []);
    return { documents };
}

export function selectDocument(slot, document) {
    return db => {
        const isSameDocument = db.getIn(['dms', 'model', 'selected', slot, 'idDocDms']) === document.get('idDocDms');
        const resDb = isSameDocument ? db : db.setIn(['dms', 'model', 'selected', slot], document);
        return [resDb, goToSlotDocumentUpload(slot)];
    };
}

export function goToSlotDocumentUpload(slot) {
    return db => {
        return db.setIn(['dms', 'model', 'active', slot], true);
    };
}
export function goToSlotAvailableDocuments(slot) {
    return db => {
        return db.removeIn(['dms', 'model', 'active', slot]);
    };
}

export function finishSlotDocumentUpload(slot, blocking) {
    return db => {
        const slots = db.getIn(['dms', 'slotList']);
        const slotKeys = Array.from(slots.keys());
        const nextSlot = slotKeys[slotKeys.indexOf(slot) + 1];
        if (!nextSlot) {
            return finishAllDocuments(blocking);
        }
        const documents = slots.get(nextSlot);
        if (documents.size === 1) {
            return db
                .setIn(['dms', 'model', 'slot'], nextSlot)
                .setIn(['dms', 'model', 'selected', nextSlot], documents.get(0))
                .setIn(['dms', 'model', 'active', nextSlot], true);
        }
        return db.setIn(['dms', 'model', 'slot'], nextSlot);
    };
}

function finishAllDocuments(blocking) {
    return db => {
        onbClient
            .post('/documents/addDocuments', extractUploadedDocuments(db.getIn(['dms', 'model'])))
            .then(loadForcedActions)
            .then(() => dispatch(dbCommitUpdate(db => db.setIn(['dms', 'model', 'done'], true))))
            .then(() => dispatch(getForcedActionStatus))
            .catch(handleServerErrors(blocking));
    };
}

const dms = subscription(db => db.get('dms', Map()));

export const getAvailableDocuments = parametric(slot =>
    subscription(du => {
        const allDocuments = du.getIn(['slotList', slot]) || List();
        const selected = du.getIn(['model', 'selected']) || Map();
        const eq = (d1, d2) => d1.get('idDocDms') === d2.get('idDocDms');
        return allDocuments.filter(d1 => !selected.find((d2, sIndex) => sIndex !== slot && eq(d1, d2)));
    }, dms)
);
export const getActiveSlotIndex = subscription(du => du.getIn(['model', 'slot'], 1), dms);
export const getLastSlotIndex = subscription(du => Array.from(du.getIn(['slotList']).keys()).pop(), dms);

export const getSlotDocument = parametric(slot => subscription(du => du.getIn(['model', 'selected', slot]), dms));

export const getSlotList = subscription(du => du.getIn(['slotList']), dms);

export const isSlotDocumentSelected = parametric(slot =>
    subscription(du => {
        return du.getIn(['model', 'active', slot]);
    }, dms)
);

export const hasAllFilesUploaded = parametric(slot =>
    subscription(du => {
        const docId = du.getIn(['model', 'selected', slot, 'idDocDms']);
        const pages = du.getIn(['model', 'selected', slot, 'pages']);
        const done = du
            .getIn(['model', 'docs', slot, docId, 'files'], Map())
            .filter(file => file && file.getIn(['upload', 'done']) === true)
            .count();
        console.log('hasAllFilesUploaded', pages, done);
        return done === pages;
    }, dms)
);
